export enum StatisticsAreaGranularityEnum {
  ChargePoint = 'charge-point',
  Location = 'location',
  Network = 'network',
}

export enum StatisticsTimeGranularityEnum {
  Year = 'year',
  Month = 'month',
  Period = 'period',
  Quarter = 'quarter',
}
